import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { references } from '../mockData';
import { Reveal } from './ui-kit';

const Logo = ({ item }) => {
  const [failed, setFailed] = useState(false);
  return (
    <div
      className="shrink-0 h-28 w-56 mx-3 rounded-2xl bg-white border border-slate-200/80 flex items-center justify-center px-6 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:border-energy/50 hover:shadow-[0_12px_30px_rgba(255,94,20,0.12)] hover:-translate-y-1 transition-all duration-300"
      data-testid={`reference-logo-${item.id}`}
    >
      {failed ? (
        <span className="font-display font-extrabold text-lg text-ink tracking-tight text-center">{item.name}</span>
      ) : (
        <img src={item.logo} alt={item.name} className="max-h-[72px] max-w-full object-contain" loading="lazy" onError={() => setFailed(true)} />
      )}
    </div>
  );
};

const References = () => {
  const loop = [...references, ...references];
  return (
    <div className="mt-12" data-testid="references-section">
      <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_12%,#000_88%,transparent)]">
        <div className="marquee flex w-max py-2">
          {loop.map((r, i) => <Logo key={`${r.id}-${i}`} item={r} />)}
        </div>
      </div>
      <Reveal delay={120} className="mt-10 max-w-3xl mx-auto text-center">
        <p className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-energy">
          <Heart size={14} className="fill-energy" /> Merci
        </p>
        <p className="mt-3 text-base md:text-lg text-slate-700 leading-relaxed" data-testid="references-thanks">
          Un grand merci à SPIE, Sipect, Eiffage, Podeliha, Saumur Habitat, Meldomys et MC IMMO pour leur confiance.
          C'est un honneur de travailler à vos côtés et de contribuer à la réussite de vos projets.
        </p>
      </Reveal>
    </div>
  );
};

export default References;
